export default __webpack_public_path__ + "static/media/feature_bg2.c9ff76a3.png";